// Routes AI voice clips through one shared analyser so the voice bars can follow them.
let ctx = null, analyser = null, data = null;

const ensure = () => {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    analyser = ctx.createAnalyser();
    analyser.fftSize = 128;
    analyser.smoothingTimeConstant = 0.7;
    analyser.connect(ctx.destination);
    data = new Uint8Array(analyser.frequencyBinCount);
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
};

// An <audio> element for this clip, played through the analyser.
export function meteredAudio(url) {
  ensure();
  const a = new Audio(url);
  ctx.createMediaElementSource(a).connect(analyser);
  return a;
}

// Loudness per bar (0..1) from the voice frequency range, or null before any voice has played.
export function readLevels(n) {
  if (!analyser) return null;
  analyser.getByteFrequencyData(data);
  const usable = Math.floor(data.length * 0.4);
  const out = [];
  for (let i = 0; i < n; i++) {
    const from = Math.floor((i / n) * usable), to = Math.max(from + 1, Math.floor(((i + 1) / n) * usable));
    let peak = 0;
    for (let j = from; j < to; j++) peak = Math.max(peak, data[j]);
    // Lift the quieter high frequencies so the whole row moves with speech.
    out.push(Math.min(1, (peak / 255) * (1 + (1.4 * i) / n)));
  }
  return out;
}
